import { Fragment, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderNavTitle from "../../component/reusableComponent/headerNavTitle/HeaderNavTitle";
import MenuRow from "../../component/reusableComponent/menuPanel/MenuRow";
import { useProfileMenuItems } from "../../component/reusableComponent/profile/useProfileMenuItems";
import { StateContext } from "../../context/globalContext/context";
import { iGlobalContext } from "../../context/globalContext/interface";
import { ROUTES } from "../../constant";
import styles from "./account.module.scss";

export default function MobileAccount(): JSX.Element | null {
  const { userInfo }: iGlobalContext = useContext(StateContext);
  const navigate = useNavigate();
  const { sections } = useProfileMenuItems();

  useEffect(() => {
    if (!userInfo?.loggedIn) navigate(ROUTES.onBoarding);
  }, [userInfo?.loggedIn, navigate]);

  if (!userInfo?.loggedIn) return null;

  return (
    <div className={`${styles.container} zv-page-anim`}>
      <HeaderNavTitle title="Account" showBack={false} />
      <div className={styles.body}>
        {sections.map((section, i) => (
          <Fragment key={section.heading}>
            {i > 0 && <div className={styles.spacer} aria-hidden="true" />}
            <p className={styles.heading}>{section.heading}</p>
            {section.items.map((item, index) => (
              <MenuRow key={index} {...item} />
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
